
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { Lead } from '@/types';

@Component
export default class LeadResolveDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;

  dialog = false
  loading = false

  @Watch('value')
  onValueChange(val: boolean) {
    console.log('LeadResolveDialog: onValueChange()'); // eslint-disable-line no-console

    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  get lead(): Lead {
    return this.$store.getters.currentLead;
  }

  async onCancel() {
    console.log('LeadResolveDialog: onCancel()'); // eslint-disable-line no-console

    this.dialog = false;
  }

  async onResolve() {
    console.log('LeadResolveDialog: onResolve()'); // eslint-disable-line no-console

    this.loading = true;

    await this.$store.dispatch('resolveLead');

    this.dialog = false;
    setTimeout(() => {
      this.loading = false;
    }, 500);
  }
}
